/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Metadata_Value_Label_InlineInputs */



/**
* | output |
* | --- |
* | "Value:" |
*
* @param {Options_Metadata_Value_Label_InlineInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_metadata_value_label_inline = /** @type {((inputs?: Options_Metadata_Value_Label_InlineInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Metadata_Value_Label_InlineInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Valeur :")
	if (locale === "de") return /** @type {LocalizedString} */ ("Wert:")
	if (locale === "it") return /** @type {LocalizedString} */ ("Valore:")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Ценить:")
	if (locale === "es") return /** @type {LocalizedString} */ ("Valor:")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("价值：")
	if (locale === "ja") return /** @type {LocalizedString} */ ("価値：")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कीमत:")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Valor:")
	return /** @type {LocalizedString} */ ("Value:")
});